import { css, SerializedStyles } from '@emotion/core';
import { Theme, subtitleText } from 'features/Theme';

const style = {
  stepLabel: (theme: Theme): SerializedStyles => css`
    ${subtitleText(theme)};
    margin: ${theme.mui.spacing(2)}px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

export default style;
